import { breakpoints, useMediaQuery } from '@coursera/cds-core';

import GrowthDiscoveryEpicClient from 'bundles/epic/clients/GrowthDiscovery';

// For general/desktop-inclusive changes, this can act as a standalone check.
export const useStreamlinedLOHP = () => {
  return GrowthDiscoveryEpicClient.preview('useStreamlinedMWebLOHP');
};

export const useMobileOnlyStreamlinedLOHP = () => {
  const streamlinedLOHP = useStreamlinedLOHP();
  const isMobileDeviceWidth = useMediaQuery(breakpoints.down('xs'));

  return isMobileDeviceWidth ? streamlinedLOHP : 'control';
};
